export const cloneDeep = (item) => {
  if (!item || typeof item !== "object") return item;
  let constructor = item.constructor();
  return Object.keys(item).reduce((acc, curr) => {
    acc[curr] = cloneDeep(item[curr]);
    return acc;
  }, constructor);
};

export const getToday = () => {
  const monthsMap = {
      0: "January",
      1: "February",
      2: "March",
      3: "April",
      4: "May",
      5: "June",
      6: "July",
      7: "August",
      8: "September",
      9: "October",
      10: "November",
      11: "December",
    },
    daysMap = {
      0: "Sunday",
      1: "Monday",
      2: "Tuesday",
      3: "Wednesday",
      4: "Thursday",
      5: "Friday",
      6: "Saturday",
    },
    today = new Date();
  return `${daysMap[today.getDay()]}, ${
    monthsMap[today.getMonth()]
  } ${today.getDate()}, ${today.getFullYear()}`;
};

export const formatAudioDuration = (duration) => {
  if (!duration) {
    return "00:00";
  }
  const durations = duration.split(":");

  if (durations.length !== 3) return "INVALID_FORMAT";
  const hours = parseInt(durations[0]),
    minutes = parseInt(durations[1]),
    seconds = parseInt(durations[2]);

  const formattedMinutes = minutes <= 9 ? "0" + minutes : minutes,
    formattedSeconds = seconds <= 9 ? "0" + seconds : seconds,
    formattedHours = hours <= 9 ? "0" + hours : hours,
    formattedDuration = formattedMinutes + ":" + formattedSeconds;

  return hours ? formattedHours + ":" + formattedDuration : formattedDuration;
};

export const pluralize = (
  singularWord,
  { count = 0, pluralWord = "", pluralizeAnyway = false, returnCount = true }
) => {
  const value = returnCount ? `${count} ` : "";
  if (!pluralizeAnyway && count === 1) return value + singularWord;
  else return pluralWord ? value + pluralWord : value + `${singularWord}s`;
};
